import React from 'react';
import '../../scss/components/Radios.scss';

interface RadiosProps {
    onChange?:any,
    name:string,
    className?:string,
    wrapperClassName?:string,
    label?:string,
    options:Array<{
        value: string,
        label: string
    }>,
    value?:string,
    error?:string,
    description?:string
}

const Radios = ({
    onChange,
    name,
    className,
    wrapperClassName,
    label,
    options,
    value,
    error,
    description
}:RadiosProps) => {
    return (
        <div className={`form-group radios${wrapperClassName ? ' ' + wrapperClassName : ''}${ !label || label.length <= 0 ? ' no-label' : '' }`}>
            {label && label.length > 0 ? (
                <div>
                    <label>
                        {label}
                        {description && description.length > 0 ? (
                            <><br /><br /><em>{description}</em></>
                        ) : <></>}
                    </label>
                </div>
            ) : <></>}
            <div className="radio-inputs-wrapper">
                {options.map((el, key) => (
                    <div className="single-radio" key={key}>
                        <input
                            type='radio'
                            name={name}
                            id={name + '_' + key}
                            value={el.value}
                            onChange={() => onChange(el.value)}
                            checked={value === el.value}
                            className={className}
                        />
                        <label htmlFor={name + '_' + key}>{el.label}</label>
                    </div>
                ))}
            </div>
            { error && (
                <p className='form-error'>{ error }</p>
            ) }
        </div>
    )
}

export default Radios;
